import { render, staticRenderFns } from "./MemberDiscount.vue?vue&type=template&id=624a93cc&scoped=true&"
import script from "./MemberDiscount.vue?vue&type=script&lang=js&"
export * from "./MemberDiscount.vue?vue&type=script&lang=js&"
import style0 from "./MemberDiscount.vue?vue&type=style&index=0&id=624a93cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a93cc",
  null
  
)

export default component.exports